import { CampaignBriefProps } from "../../../features/brief-list/types/props/campaign-brief.props";

export const sortCampaignBriefPropsByCreatedAtDesc = (
  briefs: CampaignBriefProps[]
): CampaignBriefProps[] => briefs.sort((a, b) => (a.createdAt > b.createdAt ? -1 : 1));
